import { render, staticRenderFns } from "./ClientWalletTransactionsPrint.vue?vue&type=template&id=5ae45ea2&scoped=true"
import script from "./ClientWalletTransactionsPrint.vue?vue&type=script&lang=js"
export * from "./ClientWalletTransactionsPrint.vue?vue&type=script&lang=js"
import style0 from "./ClientWalletTransactionsPrint.vue?vue&type=style&index=0&id=5ae45ea2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ae45ea2",
  null
  
)

export default component.exports